import React, { useMemo, useState } from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';

function normalizeCode(raw: string) {
  return raw.replace(/\D/g, '').slice(0, 6);
}

export function SignupEmailCodeModal(props: {
  open: boolean;
  email: string;
  isBusy: boolean;
  error?: string | null;
  onClose: () => void;
  onConfirm: (code: string) => void;
}) {
  const { open, email, isBusy, error, onClose, onConfirm } = props;
  const [code, setCode] = useState('');
  const normalized = useMemo(() => normalizeCode(code), [code]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Verificação por e-mail</DialogTitle>
      <DialogContent>
        <Alert severity="info" sx={{ mb: 2 }}>
          Enviamos um código de 6 dígitos para <strong>{email}</strong>. Ele expira em 10 minutos.
        </Alert>
        {error ? (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        ) : null}
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Informe o código para continuar a criação da conta.
        </Typography>
        <TextField
          label="Código de 6 dígitos"
          value={normalized}
          onChange={(e) => setCode(e.target.value)}
          inputProps={{ inputMode: 'numeric' }}
          fullWidth
        />
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} disabled={isBusy}>
          Cancelar
        </Button>
        <Button variant="contained" onClick={() => onConfirm(normalized)} disabled={isBusy || normalized.length !== 6}>
          Continuar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

